import { render, staticRenderFns } from "./categoriesview.vue?vue&type=template&id=502c72e4"
import script from "./categoriesview.vue?vue&type=script&lang=js"
export * from "./categoriesview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports